export default async function contactBackend<T>(
    endpointRoute: string,
    body: Record<string, unknown> = {},
    options: Record<string, any> = {}
): Promise<T> {
    const _endpoint = process.env.REACT_APP_SERVER_URL as string;
    const response = await fetch(_endpoint + endpointRoute, {
        method: "POST",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            ...options.headers
        },
        body: JSON.stringify(body)
    });

    if (!response.ok) {
        throw new Error("Request to backend failed");
    }
    return response.json();
}

export async function fileUpload<T>(body: FormData): Promise<T> {
    const _endpoint = process.env.REACT_APP_SERVER_URL as string;
    const response = await fetch(`${_endpoint}/upload`, {
        method: "POST",
        body
    });

    if (!response.ok) {
        throw new Error("Request to backend failed");
    }
    return response.json();
}